<template>
	<div
		class="flex flex-col relative size-48 border border-(--primary-brown) bg-(--card-background) rounded-sm shadow items-center justify-between p-5 transition duration-(--default-transition-duration) hover:cursor-pointer hover:scale-101 hover:shadow-lg"
		@click="openURL(props.websiteUrl)"
	>
		<div class="flex h-full items-center">
			<img
				:src="props.imageSrc"
				:alt="props.name"
				class="w-full object-contain rounded-sm"
			>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {
		IGiftProvider
	} from "~/types/supabase";

	const props = defineProps<IGiftProvider>();
	const { openURL } = useUtils();
</script>

<style scoped>

</style>